// extracted by mini-css-extract-plugin
export var standaloneTable = "_ix-0";
export var standaloneTableWithBodyFill = "_ix-1";
export var withExtraHeader = "_ix-2";